"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorResponse = void 0;
const axios_1 = __importDefault(require("axios"));
const errorResponse = (err) => {
    var _a, _b, _c;
    if (axios_1.default.isAxiosError(err)) {
        return {
            isError: true,
            errorCode: ((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) || 500,
            errorMessage: ((_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.errorMessage) || err.message
        };
    }
    return {
        isError: true,
        errorCode: 400,
        errorMessage: String(err)
    };
};
exports.errorResponse = errorResponse;
